import Wrapper from "@/components/wrapper"
import { langStore } from "@/stores/lang-store"
import { myPageBundle } from "@/routes/my/my-page-const"
import ProfileView from "@/routes/my/_components/profile-view"
import { ChevronRight, Globe, ShieldCheck } from "lucide-react"
import { useNavigate } from "react-router-dom"
import LangSwitch from "./_components/lang-switch"

const MyPage = () => {
  const navigate = useNavigate()
  const { lang } = langStore()
  const bundle = myPageBundle.password

  return (
    <div className="space-y-5">
      <ProfileView />

      <Wrapper.shadow className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-5 shadow-sm sm:p-6">
        <section>
          <div className="flex items-center gap-3">
            <div className="flex size-10 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-600">
              <Globe size={20} strokeWidth={1.8} />
            </div>

            <div className="min-w-0 flex-1">
              <h2 className="text-sm font-bold text-slate-800">
                {lang === "ko" ? "언어 설정" : lang === "es" ? "Idioma" : "Language"}
              </h2>
              <p className="mt-1 text-xs leading-relaxed text-slate-500">
                {lang === "ko"
                  ? "화면에 표시할 언어를 선택합니다."
                  : lang === "es"
                    ? "Selecciona el idioma de la interfaz."
                    : "Choose your preferred display language."}
              </p>
            </div>
          </div>

          <div className="mt-5">
            <LangSwitch />
          </div>
        </section>
      </Wrapper.shadow>

      <Wrapper.shadow className="overflow-hidden rounded-2xl border border-slate-200/80 bg-white p-0 shadow-sm">
        <button
          type="button"
          onClick={() => navigate("/my/pw/verify")}
          className="group flex w-full items-center gap-4 p-5 text-left transition-colors hover:bg-slate-50 sm:p-6"
        >
          <span className="flex size-11 shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-600 transition-colors group-hover:bg-blue-50 group-hover:text-toicos-navy">
            <ShieldCheck size={22} strokeWidth={1.8} />
          </span>

          <span className="min-w-0 flex-1">
            <strong className="block text-sm font-bold text-slate-800">{bundle.title[lang]}</strong>
            <span className="mt-1 block text-sm leading-relaxed text-slate-500">
              {bundle.description[lang]}
            </span>
          </span>

          <span className="flex shrink-0 items-center gap-1 text-sm font-medium text-slate-400 transition-colors group-hover:text-toicos-navy">
            <span className="hidden sm:inline">{bundle.open[lang]}</span>
            <ChevronRight size={19} />
          </span>
        </button>
      </Wrapper.shadow>
    </div>
  )
}

export default MyPage
